/**
 * 中文作文 model
 * */
import { BaseSubject } from '../BaseSubject.model';
import { getContentWidth } from '@/utils/contentWidth';
import store from '@/store/index';
import { PAGE_SIZE_CELL } from '@/subjects/constant';
//@ts-ignore
let answerPanelState = store.state.answerPanel;
const $ = require('jquery');
// const TAG_P_HEIGHT = 54; // 一个p元素的固定高度
import { TAG_P_HEIGHT } from '@/subjects/constant';
const NEXTPAGE_HEAD_INDEX = 0; //下一页头部的下标 默认0
const TH_HEIGHT = 42; //标题高度
const WRITE_LINE_HEIGHT = 40; // 语文作文题一行的高度
const ANSWER_HEIGHT = 300; //解答题默认高度
const ANSWER_HEIGHT_AND_TH = 340; //解答题默认高度
const BORDER_HEIGHT = 1; // 每个编辑器的border高度为1px
const MARGIN_TOP = 10; // 每道大题之间的margintop值为10px
const MARGIN_BOTTOM = 10; // 每个页面底部空白的高度值为10px
export class WriteModel extends BaseSubject {
  totalScore?: number = 50;

  /**
   * 字数默认
   * */

  wordNum?: any;

  /**
   * 计算得出来的行数
   * */

  rowCount?: any;
  /** 题目 */
  title?: any
  showStart?: any
  showScore?: any
  showTitle?: any
  constructor(obj?: {
    name?: any;
    htmlArray?: any;
    wordNum?: any;
    rowCount?: any;
    start?: any;
    totalScore?: number;
    items?: any[];
    title?: any;
    showStart?: any;
    showScore?: any;
    showTitle?: any;
  }) {
    super(obj);
    obj = obj || {};
    this.type = 5;
    this.name = obj.name || '作文（语）';
    this.wordNum = obj.wordNum || 1000; // 默认 1000 字数
    this.totalScore = obj.totalScore || 50;
    this.start = obj.start || '1';
    this.htmlArray = obj.htmlArray || [];
    this.items = [];
    this.items.push({
      no: obj.start,
    });
    this.end = '';
    this.title = obj.title
    this.showStart = obj.showStart || '1'
    this.showScore = obj.showScore || '1'
    this.showTitle = obj.showTitle || '1'
  }

  render() {
    // 渲染函数
    const contentWidth = getContentWidth(); // 获取容器宽度
    console.log('重新查看宽度', contentWidth);
    const wordNum = this.wordNum; // 总字数
    const wordWidth = 31; // 每个文字空格的宽度
    const rowWordNum = Math.floor(contentWidth / wordWidth); // 每行最多的文字空格数量
    const rowCount = (this.rowCount = Math.ceil(wordNum / rowWordNum)); // 生成多少行数据
    const htmlArray = [];
    let rowWidth = 0; // 每一行空格占用的宽度
    console.log('重新查看行数', {rowCount: rowCount,rowWordNum:rowWordNum,wordNum: wordNum });
    for (let index = 1; index <= rowCount; index++) {
      // 遍历每一行数据
      // 计算每一行的空格数
      const isLastRow = index === rowCount; // 是否最后一行
      const currentRowWordNum = rowWordNum;
      let html = ``;
      for (let idx = 1; idx <= currentRowWordNum; idx++) {
        // 循环每行数据
        const currentWordNum = idx + (index - 1) * rowWordNum; // 当前文字空格的数字
        const posHtml =
          currentWordNum % 100 === 0 ? `<div class="wri-pos">${currentWordNum}</div>` : ``;
        let styleSlot = ``;
        if (idx === currentRowWordNum) {
          styleSlot = `style="border-right: 1px solid var(--card-color);"`;
        }
        html += `<div class="wri" ${styleSlot}>${posHtml}</div>`;
      }
      if (index === 1) {
        rowWidth = $('#writing-test')
          .html(`<div>${html}</div>`)
          .width();
      }
      if (index == 1) {
        // 第一行占位 为了手批得分框不遮挡作文题
        htmlArray.push(`<div class="writing">` + `<div class="wri-list">${html}</div>` + '</div>');
      } else {
        htmlArray.push(
          `<div class="writing">` +
            (isLastRow
              ? `<div class="wri-list" >${html}</div>`
              : `<div class="wri-list">${html}</div>`) +
            '</div>'
        );
      }
    }
   this.showTitle == 1  && htmlArray.unshift(
      `<div class="writing writing-title" style="padding-left:6px;line-height: 42px;width:100%"><span>题目:</span><span style="padding-left:6px;border-bottom: 1px solid var(--card-color);display: inline-block;height: 30px;width:300px"></span></div>`
    );
    this.showStart == 1 ? htmlArray.unshift(
      `<div class="writing"><div class="wri-list writing-th" style="padding-left:6px;line-height: 42px;width:100%">${this.start}.</div></div>`
    ): this.showTitle == 1 ? htmlArray.unshift(
      `<div class="writing"><div class="wri-list" style="padding-left:6px;height: 0px;width:100%"></div></div>`
    ): null

    // 循环结束后赋值
    this.htmlArray = htmlArray;

    this.innerHTML = htmlArray.join('');    
  }

  // appendToPage() {

  // }

  appendToPage(
    state: any,
    // pageCell: { contentHeight: number; value: string[] }[],
    pageHeight: number,
    newTopicHeight: number
  ) {
    let currentPage = state.pageCell.length - 1;
    // 语文作文
    state.newTopicHeight = (this.rowCount + 1) * WRITE_LINE_HEIGHT;
    console.log('作文题', this);
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + WRITE_LINE_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        ...this,
        hasTitle: true,
        initDragHeight: (this.rowCount + 1) * WRITE_LINE_HEIGHT,
        innerHTML: this.innerHTML,
      });
      this.recursionCutWritePage(state, currentPage, state.existHeight);
    } else {
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.insertNextPageHeadStack(
        state.pageCell[currentPage],
        state.newTopicHeight,
        this.innerHTML,
        true
      );
      this.recursionCutWritePage(state, currentPage, 0);
    }
  }
  resetPage(state: any,){
    let currentPage = state.pageCell.length - 1;
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + WRITE_LINE_HEIGHT + 20)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        ...this,
        hasTitle: true,
        initDragHeight: (this.rowCount + 1) * WRITE_LINE_HEIGHT,
        innerHTML: this.innerHTML,
      });
      this.recursionCutWritePage(state, currentPage, state.existHeight);
    } else {

      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.insertNextPageHeadStack(
        state.pageCell[currentPage],
        state.newTopicHeight,
        this.innerHTML,
        true
      );
      this.recursionCutWritePage(state, currentPage, 0);
    }
  }
  /**
   *
   * @param {*} currentPage 新增的当前页的下标
   * @param {*} existHeight 新增时上面已经存在的高度（当前页）
   */
  private recursionCutWritePage(
    state: any,
    currentPage: number,
    existHeight: number,
    isSelfCall?: boolean
  ) {
    // state.loadingInstance.close();
    let { acCardYJType } = answerPanelState.answerSheet;
    let cardGapHeight = acCardYJType == 2 ? 34 : 0

    // existHeight = existHeight + (isSelfCall ? 0 : TH_HEIGHT);
    existHeight = existHeight + (isSelfCall ? 0 : TH_HEIGHT) + cardGapHeight;

    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    console.log('作文题 currentMaxHeight', currentMaxHeight);
    let canFillHeight = currentMaxHeight - existHeight- MARGIN_BOTTOM; // 可填充高度}
    if (canFillHeight < 151)  canFillHeight = 0;
    console.log('作文题 canFillHeight', canFillHeight);
    let topicHeight = state.newTopicHeight + (isSelfCall ? 0 : TH_HEIGHT) + cardGapHeight;
    // let topicHeight = state.newTopicHeight + (isSelfCall ? 0 : TH_HEIGHT);
    const currentTopicStack =
      state.pageCell[currentPage].fillTopiclist[
        state.pageCell[currentPage].fillTopiclist.length - 1
      ];
    if (topicHeight > canFillHeight) {
      const resolvetopic = this.addrResolveWriteTopic(
        currentTopicStack.innerHTML,
        canFillHeight  - cardGapHeight,
        currentTopicStack
      );

      this.innerHTML = (resolvetopic || {}).html || '';
      let resolveHeight = (resolvetopic || {}).resolveHeight || 0;
      topicHeight -= resolveHeight || canFillHeight;

      console.log('作文题 topicHeight', topicHeight);
      state.newTopicHeight = topicHeight;
      currentTopicStack.initDragHeight =
        resolveHeight + MARGIN_BOTTOM || canFillHeight - MARGIN_BOTTOM;
      currentTopicStack.isHurdle = true;
      if (this.innerHTML) {
        this.page.createNextPage(state.pageCell);
        // state.currentPageNum++;
        currentPage++;
        this.insertNextPageHeadStack(
          state.pageCell[currentPage],
          state.newTopicHeight,
          this.innerHTML
        );
        this.recursionCutWritePage(state, currentPage, 0, true);
      }

    } else {
      try {
        let ptags = this.innerHTML.split('<div class="writing">');
        ptags.shift();
        ptags = ptags.map((ptag: any) => {
          return '<div class="writing">' + ptag;
        });
        const dragPTags = parseInt(String(topicHeight / WRITE_LINE_HEIGHT)); // 拖拽高度四舍五入转换到p元素的个数
        currentTopicStack.initDragHeight = dragPTags * WRITE_LINE_HEIGHT + MARGIN_BOTTOM; //直接将剩余的高度复制给最后
        console.log('作文题剩余高度', currentTopicStack);
        currentTopicStack.isHurdle = false;
        currentTopicStack.innerHTML = this.innerHTML;
      } catch (e) {
        console.error('分解题型报错', e.message);
      }
      // state.loadingInstance.close();
      return console.log('停止递归');
    }
  }
  /**
   * 在下一页的头栈插入多出的高度
   */
  insertNextPageHeadStack(
    nextPageCell: any,
    overstepDistance: number,
    innerHTML?: string,
    hasTitle?: any
  ) {
    // nextPageCell.items.push({
    //   type: state.topticType || 1,
    // });
    nextPageCell.fillTopiclist.unshift({
      ...this,
      hasTitle: hasTitle || false,
      type: this.type,
      isHurdle: true, //当前item是否属于跨栏内容
      isResolved: false, // 题型是否分解
      initDragHeight: overstepDistance,
      innerHTML: innerHTML || '<p><u> test </u></p>',
    });
  }

  /**
   * 作文题型分解
   * @param {*} innerHTML
   * @param {*} canFillHeight
   * @param {*} currentTopicStack
   */
  addrResolveWriteTopic(innerHTML: string, canFillHeight: number, currentTopicStack: any) {
    console.log('addrResolveWriteTopic', innerHTML, canFillHeight);
    try {
      let ptags = innerHTML.split('<div class="writing">');
      ptags.shift();
      ptags = ptags.map(ptag => {
        return '<div class="writing">' + ptag;
      });
      // 这里剪掉MARGIN_BOTTOM的高度是因为有可能相除是整数或者多零点几 视图会显示贴边 所以这里要处理一下
      // MARGIN_BOTTOM*2  增加的20是因为有一个basic marginbottom 20px的距离
      const dragPTags = parseInt(String((canFillHeight - MARGIN_BOTTOM) / WRITE_LINE_HEIGHT)); // 拖拽高度四舍五入转换到p元素的个数
      const hurdleTags = ptags.splice(0, dragPTags); //剩余的数组 数组反转然后切割跨栏的小题
      // const result = ptags.join('');
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      // console.log('作文题分解题型', innerHTML, dragPTags, hurdleTags);
      return { html: ptags.join(''), resolveHeight: dragPTags * WRITE_LINE_HEIGHT };
      // return result;
    } catch (e) {
      console.error('分解题型报错', e.message);
    }
  }
}
